<script>
  export default {
    props: {
      data: {
        type: Object,
        default: () => {
          return {}
        }
      },
      text: {
        type: String,
        default: ''
      },
      contentType: {
        type: String,
        default: 'solution',
        validator(value) {
          return ['solution',
            'product',
            'news',
            'courses',
            'case',
            'video'].includes(value)
        },
      }
    },
    data() {
      return {
        // articleText,
      }
    },
    methods: {
      toNext(to) {
        const params = () => {
          return this.$route.name.includes('brand')
            ? {
              brandAlias: this.$route.params.brandAlias,
              [`${ this.contentType }Alias`]: to.alias
            }
            :
            {
              [`${ this.contentType }Alias`]: to.alias
            }
        };
        return {
          name: this.$route.name,
          params: params()
        }
      },
    }
  }
</script>
<template>
  <div :class="$style.ArticleContentFooter">
    <div class="ArticleContentFooter__footer">
      <BaseButton
        class="isStylePrimary isSmall isRadius isOutline2 ArticleContentFooter__footer__Btn"
        :to="data.to"
      >
        <i class="far fa-chevron-left text-sm align-middle"></i>
        回到{{ text }}
      </BaseButton>
      <hr class="d-lg-block d-none">
      <div :class="$style.pageArrow">
        <div class="pr-md-3 pageArrow__Box">
          <router-link
            v-if="data.prev"
            class="pageArrow__btn isPrev"
            :to="toNext(data.prev)"
          >
            <div class="pageArrow__text d-md-flex d-none">
              <i class="far fa-chevron-left text-sm mr-3"></i>
              上則{{ text }}
            </div>
            <div class="pageArrow__text d-md-none mb-2">
              <i class="far fa-chevron-left text-2sm"></i>
              上一則
            </div>
            <div class="pageArrow__title">
              {{ data.prev.title }}
            </div>
          </router-link>
        </div>
        <div class="pl-md-3 pageArrow__Box">
          <router-link
            v-if="data.next"
            class="pageArrow__btn isNext"
            :to="toNext(data.next)"
          >
            <div class="pageArrow__text d-md-flex d-none">
              下則{{ text }}
              <i class="far fa-chevron-right text-sm ml-3"></i>
            </div>
            <div class="pageArrow__title">
              {{ data.next.title }}
            </div>
            <div class="pageArrow__text d-md-none mt-2">
              下一則
              <i class="far fa-chevron-right text-2sm"></i>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" module>
  .ArticleContentFooter {
    padding-bottom: $section-padding;

    :global {
      .embed-responsive {
        margin-bottom: 3.75rem;
      }

      .ArticleContentFooter {
        &__footer {
          padding-top: 5rem;
          @include max-lg {
            padding-top: 1.1rem;
            &__Btn {
              @include max-lg {
                width: 100%;
                margin-bottom: 3rem;
              }
              @include max-md {
                margin-bottom: 1.25rem;
              }
            }
          }
        }
      }
    }
  }

  .pageArrow {
    display: flex;
    justify-content: space-between;
    @include max-md {
      display: block;
    }
    :global {
      .pageArrow {
        &__Box {
          width: 50%;
          @include max-md {
            width: 100%;
            margin-top: 1rem;
          }
        }
        &__btn {
          width: 306px;
          max-width: 306px;
          @include max-md {
            padding: 1.25rem;
            display: block;
            width: 100%;
            max-width: 100%;
            border: 1px solid $color-gray-3;
          }
          &.isPrev {
            @include max-md {
              // text-align: center;
            }
          }

          &.isNext {
            text-align: right;
            @include max-md {
              text-align: left;
            }
            .pageArrow {
              &__text {
                justify-content: flex-end;
                @include max-md {
                  // justify-content: ;
                }
              }
            }

          }

          &:hover {
            text-decoration: none;

            .pageArrow {
              &__text, &__title {
                color: $color-primary;
              }
            }
          }
        }

        &__text {
          display: flex;
          align-items: center;
          margin-bottom: 1.25rem;
          color: $color-gray-7;
          transition: color 0.3s;
          @include max-md {
            color: $color-gray-5;
            font-size: 0.8175rem;
            margin-bottom: 0;
          }
        }

        &__title {
          font-size: 1rem;
          line-height: 1.8;
          color: $color-gray-5;
          transition: color 0.3s;
          @include line-clamp(2, 3.8rem);
          @include max-md {
            color: $color-gray-7;
          }
        }
      }
    }
  }
</style>
